import React, { useEffect, useState } from 'react'
import LoadingScreen from '../loadingScreenComp/LoadingScreen'
import AcknowledgementMap from './AcknowledgementMap';
import { APIGetAllAcknowledgments, APIResponseAcknowledgement } from './APIAcknowledgeService';
import AcknowledgmentTable from './AcknowledgmentTable';

const Acknowledgement = () => {
    // Loading screen
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [acknowledgeData, setAcknowledgeData] = useState<APIResponseAcknowledgement[]>([]);

    const getAllAcknowledgement = async () => {
        setIsLoading(true);
        const response = await APIGetAllAcknowledgments();
        setIsLoading(false);
        if(response.status)
        {
            setAcknowledgeData(response.data);
        }
    }

    useEffect(() => {
        getAllAcknowledgement();
    }, [])

    useEffect(() => {})

    return (
        <div className={`container-wrapper`}>
			<span className={`title`}>Acknowledgement</span>
            <div className='acknowledgement-wrapper'>
                <div className='acknowledgement-body'>
                    <AcknowledgementMap locationData={acknowledgeData} setLocationData={setAcknowledgeData} />
                </div>
            </div>
            <div className='acknowledgement-wrapper'>
            <span className='title'>Acknowledgement Details</span>
                <div className='acknowledgement-body-details'>
                    <AcknowledgmentTable tableData={acknowledgeData}/>
                </div>
            </div>
        
            {isLoading && <LoadingScreen />}
        </div>
    )
}

export default Acknowledgement